import script from "./Page__Listings.vue?vue&type=script&setup=true&lang=js"
export * from "./Page__Listings.vue?vue&type=script&setup=true&lang=js"

import "./Page__Listings.vue?vue&type=style&index=0&id=70f7753a&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/wp-content/themes/stewartrealtor/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-70f7753a"]])

export default __exports__